import React, { createContext, useContext, useEffect, useState } from 'react'

import { createEditorStore, EditorSession } from './PuxEditorState'

interface EditorContext {
  store: ReturnType<typeof createEditorStore>
  session: EditorSession | null
  toolbar: HTMLDivElement | null
  setToolbar: (element: HTMLDivElement | null) => void
}

const PuxEditorContext = createContext<EditorContext | null>(null)

export const PuxEditorProvider: React.FC = ({ children }) => {
  const [store] = useState(createEditorStore)
  const [session, setSession] = useState(store.getState)
  const [toolbar, setToolbar] = useState<HTMLDivElement | null>(null)

  useEffect(() => {
    const update = () => setSession(store.getState())
    const unsubscribe = store.subscribe(update)
    update()
    return unsubscribe
  }, [store])

  return (
    <PuxEditorContext.Provider value={{ store, session, toolbar, setToolbar }}>
      {children}
    </PuxEditorContext.Provider>
  )
}

export function usePuxEditor(): EditorContext {
  const context = useContext(PuxEditorContext)
  if (!context) throw new Error(`Pux Editor requires PuxEditorProvider`)
  return context
}
